import Tile from '../tile';
import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

const CommonQuestions = <template>
  <a
    href="https://tio.zendesk.com/hc/en-us"
    target="_blank"
    rel="noopener noreferrer"
    class="no-underline font-normal"
  >
    <Tile @headerText={{t "dashboard_tiles.common_questions"}}>
      <:description>
        <div class="flex flex-row">
          {{t "dashboard_tiles.get_answers_to"}}
        </div>
      </:description>
      <:image>
        {{svgJar
          "social-media-marketing"
          width="100%"
          height="100%"
          role="img"
          desc=(t "svg.social_media_marketing")
        }}
      </:image>
    </Tile>
  </a>
</template>;

export default CommonQuestions;
